import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { TextContainerProps } from './TruncatedText.types';
import { ButtonWithIcon } from '@blueprint/ui';

export const Container = styled('div')(css`
    overflow-anchor: none;
`);

// For browsers which support -webkit-box, we can include an ellipsis at the
// end of the line that we're cutting from (despite the webkit prefix, this
// is supported by most modern browsers)
export const TextContainer = styled('div')<TextContainerProps>(
    ({ lines, height, isExpanded }) => {
        return css`
            position: relative;
            overflow: hidden;
            height: ${height ? `${height}px` : 'auto'};
            transition: height 400ms ease-in-out;

            ${!isExpanded &&
            `
            @supports (display: -webkit-box) {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: ${lines};
            }
            `}
        `;
    }
);

export const ToggleButton = styled(ButtonWithIcon)(({ theme }) => {
    const extraTouchAreaPadding = theme.spacing['16px'];

    return css`
        display: flex;
        padding: ${extraTouchAreaPadding};
        margin: 0 auto;
        margin-top: -${extraTouchAreaPadding};
    `;
});

export const RichText = styled('div')(({ theme }) => {
    return css`
        font-family: inherit;
        line-height: ${theme.type.lineHeight};
        color: ${theme.colors['text-body']};
    `;
});
